import { FormHelperText } from 'apollo-react';
import Button from 'apollo-react/components/Button';
import Card from 'apollo-react/components/Card';
import CardContent from 'apollo-react/components/CardContent';
import CardHeader from 'apollo-react/components/CardHeader';
import Container from 'apollo-react/components/Container';
import DatePicker from 'apollo-react/components/DatePicker';
import Grid from 'apollo-react/components/Grid';
import Select from '@mui/material/Select';
import TextField from 'apollo-react/components/TextField';
import Typography from 'apollo-react/components/Typography';
import React, { useReducer,useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { replace, useLocation, useNavigate } from 'react-router-dom';
import ConfirmDialog from '../common/ConfirmDialog';
import { API_URL, OBJ_ROLE, SYS_ROLE } from '../common/Constants';
import DetailDialog from '../common/DetailDialog';
import Dialog from '../common/Dialog';
import Loading from '../common/Loading';
//import { getApi, getFuncroleFlg, postApi, setURL, redirectToLogin, } from '../common/Utils';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import { Box } from '@mui/material';
import './UpdateUser.scss';
import selectItemUserRoleList from '../json/selectItemUserRoleList.json';
import selectItemOrgList from '../json/selectItemOrgList.json';
import Tooltip from '@mui/material/Tooltip';
import funcroleData from '../json/funcroleData.json';
import selectItemGetIqviaCode from '../json/iqviaCode.json';
import Autocomplete from '@mui/material/Autocomplete';
import folderPermissionsData from '../json/folderPermissionsData.json';
import resendInviteTargetCheckData from '../json/resendInviteTargetCheckData.json';
//import { getApi, getFuncroleFlg, postApi, deleteApi, setURL, redirectToLogin } from '../common/Utils'; //後で修正
import { getApi, getFuncroleFlg, postApi, deleteApi, setURL, redirectToLogin } from '../common/Utils';


var iqviaOrgCode = "";


/**												
 * 納品アップロード_変更												
 */
function UpdateUser() {
	const location = useLocation();
	const [t] = useTranslation();
	const navigate = useNavigate();
	const [isLoading, setIsLoading] = useState(true);
	const DIALOG_STATUS = {
		NO_DIALOG: '0',
		OK_DIALOG: '1',
		DETAIL_DIALOG: '2',
		CONFIRM_DIALOG: '3',
		COMPLETE_DIALOG: '4',
		OK_DIALOG_BACK: '5',
		DETAIL_DIALOG_BACK: '6',
		DELETE_CONFIRM_DIALOG: '7', // 追加
		RESEND_INVITE_CONFIRM_DIALOG: '8', // 追加
	};


	// DB見直しの際はこちらを修正すること											
	const admin = '管理者';
	const adminCode = '000';

	// 確認ダイアログ表示用フラグ											
	const [dialogStatus, setDialogStatus] = useState(DIALOG_STATUS.NO_DIALOG);
	const [dialogOpen, setDialogOpen] = useState(false);
	const [dialogContent, setDialogContent] = useState('');
	const [detailContent, setDetailContent] = useState('');
	const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
	const [confirmDialogContent, setConfirmDialogContent] = useState('');

	// 各種権限											
	const [flgUserNameJp, setFlgUserNameJp] = useState(false);
	const [flgUserNameEn, setFlgUserNameEn] = useState(false);
	const [flgOrg1Selector, setFlgOrg1Selector] = useState(false);
	const [flgMailAddress, setFlgMailAddress] = useState(false);
	const [flgExpiryDate, setFlgExpiryDate] = useState(false);
	// 削除権限フラグを追加
	const [deleteUserBtnAuthFlg, setDeleteUserBtnAuthFlg] = useState(false);
	// 招待メール再送対象フラグを追加
	const [resendInviteTargetFlg, setResendInviteTargetFlg] = useState(false);

	// ユーザー管理画面からの値をもとに値をセットする
	const { userid, dspUsrCode, userName, userEng, org0Abbr, org1Abbr, email, usrroleDesc, expiryDate } = location.state || {};

	// ユーザー登録情報の入力内容											
	const [formValues, setFormValues] = useState({
		userid: userid,
		userNameJp: userName,
		userNameEn: userEng,
		orgLevel0Code: '',
		orgLevel1Code: '',
		email: email,
		usrroleCode: '',
		expiryDate: expiryDate,
		usrroleCodeBefore: '',
		departmentName: '',
	});
	// ユーザー追加権限フラグ											
	const [updateUserAuthFlg, setUpdateUserAuthFlg] = useState(false);
	// ユーザー保存フラグ											
	const [updateUserSaveBtnAuthFlg, setUpdateUserSaveBtnAuthFlg] = useState(false);
	// 企業名の選択リスト											
	const [compList, setCompList] = useState([]);
	// 権限の選択リスト											
	const [userRoleList, setUserRoleList] = useState([]);

	// フォルダ権限データを管理する状態を追加
	const [folderPermissions, setFolderPermissions] = useState([]);
	
	// 会社情報のセット											
	const setUserCompanyInfo = (response) => {
		// 会社名からorg0codeを取得してセットする										
		const tempCompList = response;
		const selectedComp = tempCompList.find(comp => comp.comp === org0Abbr);
		const selectedCompCode = selectedComp ? selectedComp.orgLevel0Code : null;
		formValues.orgLevel0Code = selectedCompCode;

		// 部署名からorg1codeを取得してセットする										
		const selectedDept = tempCompList.flatMap(item => item.orgLevel1Infos).find(orgLevel1Info => orgLevel1Info.dept === org1Abbr);
		const selectedDeptCode = selectedDept ? selectedDept.orgLevel1Code : null;
		formValues.orgLevel1Code = selectedDeptCode;
	}

	const [filteredOrgLevel1Infos, setFilteredOrgLevel1Infos] = useState([]);
	const [filteredUserRoleDescs, setFilteredUserRoleDescs] = useState([]);
	const forceUpdate = useReducer(() => ({}), {})[1];

	// 部署コードのフィルタリングをするための処理											
	const SetFilteringDeptAndRole = (response) => {

		const tempCompList = response;
		const selectedCode = formValues.orgLevel0Code;

		// 選択されたorgLevel0Codeに基づいてorgLevel1Infosをフィルタリング										
		const selectedComp = tempCompList.find(comp => comp.orgLevel0Code === selectedCode);
		setFilteredOrgLevel1Infos(selectedComp ? selectedComp.orgLevel1Infos : []);

	};

	// 権限セット											
	const setUserRoleInfo = (response) => {
		const tempUserList = response;
		// 権限名からroleDescを取得してセットする										
		const selectedRole = tempUserList.find(role => role.usrroleDesc === usrroleDesc);
		const selectedRoleCode = selectedRole ? selectedRole.usrroleCode : null;
		formValues.usrroleCode = selectedRoleCode;
		formValues.usrroleCodeBefore = selectedRoleCode;

		let filteredInfos;
		if (usrroleDesc === admin) {
			filteredInfos = ([{
				usrroleCode: adminCode,
				usrroleDesc: admin
			}]);
			formValues.usrroleCode = adminCode;
			formValues.usrroleCodeBefore = adminCode;
		}
		else {

			if(iqviaOrgCode === "")
			{
				const message = "企業コードが取得できませんでした。";
				setDialogStatus(DIALOG_STATUS.OK_DIALOG);
				setDialogOpen(true);
				setDialogContent(message);
			}

			//// 特定のorgLevel0Codeの場合、「利用者」を除外他は利用者のみ選択可能									
			if (formValues.orgLevel0Code === iqviaOrgCode) {
				filteredInfos = tempUserList.filter(userRoleList => userRoleList.usrroleDesc !== t('client') && userRoleList.usrroleDesc !== t('limitedClient'));
			}
			else {
				filteredInfos = tempUserList.filter(userRoleList => userRoleList.usrroleDesc === t('client') || userRoleList.usrroleDesc === t('limitedClient'));
			}
		}
		setFilteredUserRoleDescs(filteredInfos);
	}

	/**											
	 * 共通エラー処理											
	 * @param {object} error エラーオブジェクト											
	 * @param {string} detailErrorMessage 詳細ダイアログに設定するエラーメッセージ											
	 */
	const commonError = (error, detailErrorMessage) => {
		if (error.name === 'MaintenanceApiError') {
			navigate('/', { state: { maintenanceFlg: true, } });
		} else if (error.name === 'CustomApiError') {
			const message = error.message;
			setDialogStatus(DIALOG_STATUS.OK_DIALOG);
			setDialogOpen(true);
			setDialogContent(message);
		} else {
			setDialogStatus(DIALOG_STATUS.DETAIL_DIALOG);
			setDialogOpen(true);
			setDialogContent(detailErrorMessage);
			setDetailContent(error.stack);
		}
	};

	/**											
	 * ユーザー登録変更ボタン押下時の処理											
	 */
	const handleUpdateUserBtnClick = () => {

		const atIndex = formValues.email.indexOf('@');
		const domain = formValues.email.slice(atIndex + 1);

		const validDomains = {
			mail1: "iqvia.com",
			mail2: "ims.health.com",
			mail3: "quintiles.com"
		};

		if(iqviaOrgCode === "")
			{
				const message = "企業コードが取得できませんでした。";
				setDialogStatus(DIALOG_STATUS.OK_DIALOG);
				setDialogOpen(true);
				setDialogContent(message);
			}

		if (formValues.orgLevel0Code === iqviaOrgCode && Object.values(validDomains).includes(domain) == false) {
			var message = t('message.1001740');
			setDialogStatus(DIALOG_STATUS.OK_DIALOG);
			setDialogOpen(true);
			setDialogContent(message)
		}
		else if (formValues.orgLevel0Code !== iqviaOrgCode && Object.values(validDomains).includes(domain) == true) {
			var message = t('message.1001730');
			setDialogStatus(DIALOG_STATUS.OK_DIALOG);
			setDialogOpen(true);
			setDialogContent(message)
		}
		else {
			var message = "";
			message = t('message.1002100');
			setDialogStatus(DIALOG_STATUS.CONFIRM_DIALOG);
			setConfirmDialogOpen(true);
			setConfirmDialogContent(message)
		}
	}

	/**
	 * 機能権限情報取得APIの成功時の処理
	 */
	function funcroleApiSuccess(response) {
		localStorage.setItem('funcroleList', JSON.stringify(response));
	};

	/**
	 * 機能権限情報取得APIの失敗時の処理
	 * @param {object} error エラーオブジェクト
	 */
	function funcroleApiError(error) {
		const detailErrorMessage = '機能権限情報取得処理でエラーが発生しました。\n(An error occurred during the function authority information acquisition process.)';
		commonError(error, detailErrorMessage);
		//認証期限切れの場合は再ログイン
		redirectToLogin();
	};

	/**
	 * ダイアログでOKボタン押下時の処理
	 */
	const onOk = () => {
		setDialogStatus(DIALOG_STATUS.NO_DIALOG);
		setDialogOpen(false);
		if (dialogStatus === DIALOG_STATUS.OK_DIALOG_BACK || dialogStatus === DIALOG_STATUS.DETAIL_DIALOG_BACK || dialogStatus === DIALOG_STATUS.COMPLETE_DIALOG) {
			const usrData = JSON.parse(localStorage.getItem('userid'));
			const sessionUserid = usrData.userid;
			if(userid === sessionUserid && formValues.usrroleCodeBefore < formValues.usrroleCode) //ユーザーロールコードは小さいほうが権限は上なので不等号で処理する
			{
				// 機能権限情報取得API
				const urlFuncrole = setURL(API_URL.FUNCROLE);
				const getFuncroleApiParam = {
					url: urlFuncrole,
					sysRole: SYS_ROLE.PORTAL,
					success: funcroleApiSuccess,
					error: funcroleApiError,
					json: funcroleData,
				}
				getApi(getFuncroleApiParam);

				navigate('/');
			}
			else
			{
				navigate('/userManagement');
			}
		}
	};

	/**											
	 * 確認ダイアログでキャンセルボタン押下時の処理											
	 */
	const onCancel = () => {
		setDialogStatus(DIALOG_STATUS.NO_DIALOG);
		setConfirmDialogOpen(false);
	};

	/**											
	 * キャンセルボタン押下時の処理											
	 */
	const handleCancelClick = () => {
		commonBack();
	}

	/**
	 * 削除ボタン押下時の処理
	 */
	const handleDeleteUserBtnClick = () => {
		const message = t('message.1005100'); // 削除確認メッセージ
		setDialogStatus(DIALOG_STATUS.DELETE_CONFIRM_DIALOG);
		setConfirmDialogOpen(true);
		setConfirmDialogContent(message);
	}

	/**
	 * 削除確認ダイアログでOKボタン押下時の処理
	 */
	const onDeleteUserConfirmOK = async () => {
		// 削除API呼び出し処理
		const url = setURL(API_URL.USER_DELETE);
		
		// sessionUserEmailを取得
		const emailData = JSON.parse(localStorage.getItem('email'));
		const sessionUserEmail = emailData.email;
		
		// クエリパラメータとして送信
		const deleteApiParam = {
			url: url + `?userid=${formValues.userid}&sessionUserEmail=${encodeURIComponent(sessionUserEmail)}`,
			sysRole: SYS_ROLE.UPDATE_USER,
			success: deleteUserSuccess,
			error: deleteError,
		};
		
		await deleteApi(deleteApiParam);
	};
	
	/**
	 * 招待メール再送ボタン押下時の処理
	 */
	const handleResendInviteBtnClick = () => {
		const message = t('message.1005400'); // ユーザ初期設定招待メール再送確認メッセージ
		setDialogStatus(DIALOG_STATUS.RESEND_INVITE_CONFIRM_DIALOG);
		setConfirmDialogOpen(true);
		setConfirmDialogContent(message);
	}

	/**
	 * 招待メール再送確認ダイアログでOKボタン押下時の処理
	 */
	const onResendInviteConfirmOK = async () => {
		const url = setURL(API_URL.RESEND_INVITE);
		
		const emailData = JSON.parse(localStorage.getItem('email'));
		const sessionUserEmail = emailData.email;
		
		let formData = new FormData();
		formData.append('userid', formValues.userid);
		formData.append('email', formValues.email);
		formData.append('userName', formValues.userNameJp);
		formData.append('userEng', formValues.userNameEn);
		formData.append('orgLevel0Code', formValues.orgLevel0Code);
		formData.append('departmentName', formValues.departmentName);
		formData.append('sessionUserEmail', sessionUserEmail);
		
		const postApiParam = {
			url: url,
			sysRole: SYS_ROLE.UPDATE_USER,
			body: formData,
			success: resendInviteSuccess,
			error: resendInviteError,
		};
		
		await postApi(postApiParam);
	};

	/**											
	 * 共通ユーザー管理画面遷移処理											
	 */
	const commonBack = () => {
		navigate('/userManagement');
	};

	/**											
	 * ユーザー追加APIの成功時の処理											
	 */
	function updateUserSuccess() {
		setDialogStatus(DIALOG_STATUS.COMPLETE_DIALOG);
		const message = t('message.1002200');
		setDialogOpen(true);
		setDialogContent(message);
	};

	/**
	 * ユーザー削除APIの成功時の処理
	 */
	function deleteUserSuccess() {
		setDialogStatus(DIALOG_STATUS.COMPLETE_DIALOG);
		const message = t('message.1005200'); // 削除完了メッセージ
		setDialogOpen(true);
		setDialogContent(message);
	};

	/**
	 * 招待メール再送APIの成功時の処理
	 */
	function resendInviteSuccess() {
		setDialogStatus(DIALOG_STATUS.COMPLETE_DIALOG);
		const message = t('message.1005300');  // 招待メール再送メッセージ
		setDialogOpen(true);
		setDialogContent(message);
	};

	/**
	 * 招待メール再送APIの失敗時の処理
	 * @param {object} error エラーオブジェクト
	 */
	function resendInviteError(error) {
		if (error.name === 'MaintenanceApiError') {
			navigate('/', { state: { maintenanceFlg: true, } });
		} else if (error.name === 'CustomApiError') {
			const message = error.message;
			setDialogStatus(DIALOG_STATUS.OK_DIALOG);
			setDialogOpen(true);
			setDialogContent(message);
		} else {
			const message = '招待メール再送処理でエラーが発生しました。\n(An error occurred during the resend invitation process.)';
			setDialogStatus(DIALOG_STATUS.DETAIL_DIALOG);
			setDialogOpen(true);
			setDialogContent(message);
			setDetailContent(error.stack);
		}
		redirectToLogin();
	}

	/**											
	 * アップロードAPIの失敗時の処理											
	 * @param {object} error エラーオブジェクト											
	 */
	function uploadError(error) {
		if (error.name === 'MaintenanceApiError') {
			navigate('/', { state: { maintenanceFlg: true, } });
		} else if (error.name === 'CustomApiError') {
			//入力テキストに禁則文字が含まれている場合、azureのインフラルールによりエラーとなる									
			//ただし、エラーは403 Forbiddenとしか返って来ない（＝禁則文字によるエラーだと判別できない）ため、メッセージを変更する									
			const forbidCharPat1 = /.+403 Forbidden.+/;
			const forbidCharPat2 = /.+Microsoft-Azure-Application-Gateway.+/;
			if ((error.message.match(forbidCharPat1)) && (error.message.match(forbidCharPat2))) {
				const message = t('message.1000810');
				setDialogStatus(DIALOG_STATUS.OK_DIALOG);
				setDialogOpen(true);
				setDialogContent(message);

				//認証期限切れの場合は再ログイン								
				redirectToLogin();
			} else {
				const message = error.message;
				setDialogStatus(DIALOG_STATUS.OK_DIALOG);
				setDialogOpen(true);
				setDialogContent(message);

				//認証期限切れの場合は再ログイン								
				redirectToLogin();
			}
		} else {
			const message = 'アップデート処理でエラーが発生しました。\n(An error occurred during the update process.)';
			setDialogStatus(DIALOG_STATUS.DETAIL_DIALOG);
			setDialogOpen(true);
			setDialogContent(message);
			setDetailContent(error.stack);

			//認証期限切れの場合は再ログイン									
			redirectToLogin();
		}

		//認証期限切れの場合は再ログイン										
		redirectToLogin();
	};

	function deleteError(error) {
		if (error.name === 'MaintenanceApiError') {
			navigate('/', { state: { maintenanceFlg: true, } });
		} else if (error.name === 'CustomApiError') {
			const message = error.message;
			setDialogStatus(DIALOG_STATUS.OK_DIALOG);
			setDialogOpen(true);
			setDialogContent(message);
		} else {
			const message = 'ユーザー削除処理でエラーが発生しました。\n(An error occurred during the user deletion process.)';
			setDialogStatus(DIALOG_STATUS.DETAIL_DIALOG);
			setDialogOpen(true);
			setDialogContent(message);
			setDetailContent(error.stack);
		}
		redirectToLogin();
	}

	/**											
	 * ユーザー追加時の確認ダイアログでOKボタン押下時の処理											
	 */
	const onUpdateUserConfirmOK = async () => {
		// アップロードAPI										
		const url = setURL(API_URL.USER_UPSERT);
		let formData = new FormData();
		formData.append('forInsert', false);
		formData.append('userid', formValues.userid);
		formData.append('userName', formValues.userNameJp);
		formData.append('userEng', formValues.userNameEn);
		formData.append('orgLevel0Code', formValues.orgLevel0Code);
		formData.append('email', formValues.email);
		formData.append('usrroleCode', formValues.usrroleCode);
		formData.append('departmentName', formValues.departmentName);
		formData.append('usrroleCodeBefore', formValues.usrroleCodeBefore);

		// 部署登録フォームでの登録対策のため再度入れ込み
		const matchedDept = filteredOrgLevel1Infos.find(dept => dept.dept === formValues.departmentName);
		if (matchedDept) {
			formData.append('orgLevel1Code', matchedDept.orgLevel1Code);
		} else {
			formData.append('orgLevel1Code', "");
		}

		const expiryDateConvert = new Date(formValues.expiryDate);
		const option = { year: 'numeric', month: '2-digit', day: '2-digit' };
		const formattedExpiryDate = expiryDateConvert.toLocaleDateString('ja-JP', option).split("/").join("-");
		formData.append('expiryDate', formattedExpiryDate);

		const emailData = JSON.parse(localStorage.getItem('email'));
		const sessionUserEmail = emailData.email;
		formData.append('sessionUserEmail', sessionUserEmail);

		const postApiParam = {
			url: url,
			sysRole: SYS_ROLE.UPDATE_USER,
			body: formData,
			success: updateUserSuccess,
			error: uploadError,
		};
		postApi(postApiParam);
	};

	/**											
	 * 企業情報取得APIの成功時の処理											
	 * @param {array} response 企業情報取得APIのレスポンス											
	 */
	function complistApiSuccess(response) {
		// サービス名選択リストをセット										
		setCompList(response);
		setUserCompanyInfo(response);
		SetFilteringDeptAndRole(response);
	};

	/**											
	 * 企業情報取得APIの失敗時の処理											
	 * @param {object} error エラーオブジェクト											
	 */
	function complistApiError(error) {
		const detailErrorMessage = '企業情報取得処理でエラーが発生しました。\n(An error occurred during the getorglist process.)';
		commonError(error, detailErrorMessage);

		//認証期限切れの場合は再ログイン										
		redirectToLogin();
	};

	/**											
	 * 権限情報取得APIの成功時の処理											
	 * @param {array} response 部署情報取得APIのレスポンス											
	 */
	function roleListApiSuccess(response) {
		// 部署名選択リストをセット										
		setUserRoleList(response);
		setUserRoleInfo(response);
	};

	/**											
	 * 権限情報取得APIの失敗時の処理											
	 * @param {object} error エラーオブジェクト											
	 */
	function roleListApiError(error) {
		const detailErrorMessage = '権限情報取得処理でエラーが発生しました。\n(An error occurred during the getrolelist process.)';
		commonError(error, detailErrorMessage);

		//認証期限切れの場合は再ログイン										
		redirectToLogin();
	};

	/**
 * フォルダ権限取得APIの成功時の処理
 * @param {array} response フォルダ権限取得APIのレスポンス
 */
	function folderPermissionsApiSuccess(response) {
		// 本番環境ではresponseを使用
		setFolderPermissions(response);
		
		// ローカルデバッグ用：JSONファイルのデータを使用
		//setFolderPermissions(folderPermissionsData);
		
		//Debug
		//folderPermissions.length = 0;

	};

	/**
	 * フォルダ権限取得APIの失敗時の処理
	 * @param {object} error エラーオブジェクト
	 */
	function folderPermissionsApiError(error) {
		const detailErrorMessage = 'フォルダ権限取得処理でエラーが発生しました。\n(An error occurred during the folder permissions process.)';
		commonError(error, detailErrorMessage);
		redirectToLogin();
	};

	/**
	 * 招待メール再送対象確認APIの成功時の処理
	 * @param {object} response APIレスポンス
	 */
	function resendInviteTargetCheckApiSuccess(response) {
		setResendInviteTargetFlg(response.isTarget || false);
	};


	/**
	 * 招待メール再送対象確認APIの失敗時の処理
	 * @param {object} error エラーオブジェクト
	 */
	function resendInviteTargetCheckApiError(error) {
		const detailErrorMessage = '招待メール再送対象確認処理でエラーが発生しました。\n(An error occurred during the resend invite target check process.)';
		commonError(error, detailErrorMessage);
		redirectToLogin();
	};


	// 各項目バリデーション
	const [nameJpVali, setNameJpVali] = useState(false);
	const [nameEnVali, setNameEnVali] = useState(false);
	const [org0Vali, setOrg0Vali] = useState(false);
	const [org1Vali, setOrg1Vali] = useState(false);
	const [emailVali, setEmailVali] = useState(false);
	const [roleVali, setRoleVali] = useState(false);

	// ユーザー名のバリデーション											
	const validateUserid = (value) => {
		if (value.length > 50) {
			return format(t('message.1000300'), t('userId'), 50);
		}
		if (formValues.orgLevel0Code != iqviaOrgCode && value === '') {
			return t('message.1001710');
		}
		return '';
	};

	// 日本語名のバリデーション											
	const validateUserNameJp = (value) => {
		if (value.length > 30) {
			return format(t('message.1000300'), t('userNameJp'), 30);
		}
		if (!value.includes(' ') && !value.includes('　')) {
			return t('message.1001700');
		}
		return '';
	};

	// 英語名のバリデーション											
	const validateUserNameEng = (value) => {
		if (value.length > 60) {
			return format(t('message.1000300'), t('userNameEn'), 60);
		}
		if (!value.includes(' ')) {
			return t('message.1001800');
		}
		return '';
	};

	// メールアドレスのバリデーション											
	const validateMail = (value) => {
		if (value.length > 300) {
			return format(t('message.1000300'), t('email'), 300);
		}
		if (!value.includes('@')) {
			return t('message.1001900');
		}
		return '';
	};

	// 会社選択のバリデーション											
	const validateComp = (value) => {
		if (!value) {
			return format(t('message.1000200'), t('company'));
		}
		return '';
	};

	// 部署選択のバリデーション											
	const validateDept = (value) => {
		if (!value) {
			return format(t('message.1000200'), t('department'));
		}
		return '';
	};

	// 権限選択のバリデーション											
	const validateRole = (value) => {
		if (!value) {
			return format(t('message.1000200'), t('authority'));
		}
		return '';
	};

	// 有効期限のバリデーション											
	const validateExpiryDate = (value) => {
		if (!value || formValues.expiryDate === '2999/12/31') {
			return t('message.1002000');
		}
		return '';
	};

	// C#のプレースホルダーをJavascriptで使用するための処理											
	const format = (str, ...args) => {
		for (const [i, arg] of args.entries()) {
			const regExp = new RegExp(`\\{${i}\\}`, 'g')
			str = str.replace(regExp, arg)
		}
		return str
	}

	// const [iqviaOrgCode,setIqviaOrgCode] = useState('');

	/**
	 * IQVIAコード取得API成功処理
	 * @param {array} response
	 */
	function getIqviaCodeApiSuccess(response) {
		// setIqviaOrgCode(response.iqviaOrgCode);
		iqviaOrgCode = response.iqviaOrgCode;
	};

	/**
	 * IQVIAコード取得APIの失敗時の処理
	 * @param {object} error
	 */
	function getIqviaCodeApiError(error) {
		const detailErrorMessage = '組織コード情報取得処理でエラーが発生しました。\n(An error occurred during the getorginfo process.)';
		commonError(error, detailErrorMessage);

		//認証期限切れの場合は再ログイン
		redirectToLogin();
	};
	

	useEffect(() => {
		const fetchData = async () => {
			if (window.localStorage.getItem(['token']) === null) {
				navigate('/')
				return;
			}

			// 権限系設定									
			// ユーザー追加画面保存ボタン権限を設定									
			setUpdateUserSaveBtnAuthFlg(getFuncroleFlg(SYS_ROLE.UPDATE_USER, OBJ_ROLE.SAVE_BTN));

			// 削除ボタン権限を設定
			const deleteUserBtnFlg = getFuncroleFlg(SYS_ROLE.UPDATE_USER, OBJ_ROLE.USER_DELETE_BTN);
			setDeleteUserBtnAuthFlg(deleteUserBtnFlg);			

			// ユーザー名JPの権限フラグを設定									
			const userNameJpFlg = getFuncroleFlg(SYS_ROLE.UPDATE_USER, OBJ_ROLE.USER_NAME_JP);
			setFlgUserNameJp(userNameJpFlg);

			// ユーザー名ENの権限フラグを設定									
			const userNameEnFlg = getFuncroleFlg(SYS_ROLE.UPDATE_USER, OBJ_ROLE.USER_NAME_EN);
			setFlgUserNameEn(userNameEnFlg);

			// 部署名選択の権限フラグを設定									
			const org1selectorFlg = getFuncroleFlg(SYS_ROLE.UPDATE_USER, OBJ_ROLE.ORG1_SELECTOR);
			setFlgOrg1Selector(org1selectorFlg);

			// メールアドレスの権限フラグを設定									
			const mailAddressFlg = getFuncroleFlg(SYS_ROLE.UPDATE_USER, OBJ_ROLE.MAIL_ADDRESS);
			setFlgMailAddress(mailAddressFlg);

			// 有効期限の権限フラグを設定									
			const expiryDateFlg = getFuncroleFlg(SYS_ROLE.UPDATE_USER, OBJ_ROLE.EXPIRY_DATE);
			setFlgExpiryDate(expiryDateFlg);

			// orgcode取得
			const iqviacodeurl = setURL(API_URL.SELECT_ITEM_GET_IQVIACODE);
			const getIqviaCodeApiParam = {
				url: iqviacodeurl,
				sysRole: SYS_ROLE.ADD_USER,
				success: getIqviaCodeApiSuccess,
				error: getIqviaCodeApiError,
				json: selectItemGetIqviaCode,
			}
			await getApi(getIqviaCodeApiParam);

			// // 会社・部署取得API									
			const url = setURL(API_URL.SELECT_ITEM_ORGLIST);
			const getApiParam = {
				url: url,
				sysRole: SYS_ROLE.UPDATE_USER,
				success: complistApiSuccess,
				error: complistApiError,
				json: selectItemOrgList,
			}
			await getApi(getApiParam);

			// // 権限取得API									
			const roleurl = setURL(API_URL.SELECT_ITEM_USER_ROLE_LIST) + '?';
			// クエリパラメータ作成
			const params = {};
			params['showAdmin'] = false;
			const urlSearchParam =  String(new URLSearchParams(params));
			const getRoleApiParam = {
				url: roleurl + urlSearchParam,
				sysRole: SYS_ROLE.UPDATE_USER,
				success: roleListApiSuccess,
				error: roleListApiError,
				json: selectItemUserRoleList,
			}
			await getApi(getRoleApiParam);

			// フォルダ権限取得API
			const folderPermUrl = setURL(API_URL.FOLDER_PERMISSIONS);
			const getFolderPermApiParam = {
				url: folderPermUrl + `?userid=${userid}`,
				sysRole: SYS_ROLE.UPDATE_USER,
				success: folderPermissionsApiSuccess,
				error: folderPermissionsApiError,
				json: folderPermissionsData, // JSONファイルを作成する必要があります
			}
			await getApi(getFolderPermApiParam);

			// 招待メール再送対象確認API
			const resendInviteCheckUrl = setURL(API_URL.RESEND_INVITE_TARGET_CHECK);
			const getResendInviteCheckApiParam = {
				url: resendInviteCheckUrl + `?userid=${userid}`,
				sysRole: SYS_ROLE.UPDATE_USER,
				success: resendInviteTargetCheckApiSuccess,
				error: resendInviteTargetCheckApiError,
			}
			await getApi(getResendInviteCheckApiParam);
			setIsLoading(false);
		};
		fetchData();
	}, []);

	// バリデーションチェック用useEffect
	useEffect(() => {
		const validationMessage = validateUserNameJp(formValues.userNameJp);
		setNameJpVali(validationMessage === '');
	}, [formValues.userNameJp]);

	useEffect(() => {
		const validationMessage = validateUserNameEng(formValues.userNameEn);
		setNameEnVali(validationMessage === '');
	}, [formValues.userNameEn]);

	useEffect(() => {
		const validationMessage = validateMail(formValues.email);
		setEmailVali(validationMessage === '');
	}, [formValues.email, formValues.userId, formValues.orgLevel0Code]);

	useEffect(() => {
		const validationMessage = validateComp(formValues.orgLevel0Code);
		setOrg0Vali(validationMessage === '');
	}, [formValues.orgLevel0Code]);

	useEffect(() => {
		const validationMessage = validateDept(formValues.departmentName);
		setOrg1Vali(validationMessage === '');
	}, [formValues.departmentName]);

	useEffect(() => {
		const validationMessage = validateRole(formValues.usrroleCode);
		setRoleVali(validationMessage === '');
	}, [formValues.usrroleCode]);

	// 部署名を変更した際の処理
	useEffect(() => {
		const matchedDept = filteredOrgLevel1Infos.find(dept => dept.dept === formValues.departmentName);
		if (matchedDept) {
			formValues.department = matchedDept.orgLevel1Code;
		} else {
			formValues.department = "";
		}
	}, [formValues.departmentName]);

	if (isLoading) {
		// ロード中の場合はローディング画面										
		return (
			<Loading />
		);
	} else {
		return (
			<Container className="updateUser" maxWidth="md">

				<Card className="card">
					<CardHeader
						title={t('updateUserPage')}
						className="custom-card-header"
					/>
					<CardContent>
						<Grid container>
							<Box display="flex" alignItems="center" width="100%">
								<Typography className="label">{t('userId')}</Typography>
								<TextField
									id="outlined-disabled"
									className="textField"
									value={dspUsrCode}
									disabled
									FormHelperTextProps={{ className: 'red-helper-text' }}
								/>
							</Box>
							<Box display="flex" alignItems="center" width="100%">
								<Typography className="label">{t('userNameJp')}</Typography>
								<TextField
									className="textField"
									value={formValues.userNameJp}
									disabled={!flgUserNameJp}
									helperText={validateUserNameJp(formValues.userNameJp)}
									onChange={(e) => setFormValues({ ...formValues, userNameJp: e.target.value })}
									FormHelperTextProps={{ className: 'red-helper-text' }}
									placeholder={t('placeholder.1000100')}
								/>
							</Box>
							<Box display="flex" alignItems="center" width="100%">
								<Typography className="label">{t('userNameEn')}</Typography>
								<TextField
									className="textField"
									value={formValues.userNameEn}
									disabled={!flgUserNameEn}
									helperText={validateUserNameEng(formValues.userNameEn)}
									onChange={(e) => setFormValues({ ...formValues, userNameEn: e.target.value })}
									FormHelperTextProps={{ className: 'red-helper-text' }}
									placeholder={t('placeholder.1000200')}
								/>
							</Box>

							<Box display="flex" className="boxDrop" alignItems="center" width="100%">
								<Typography className="label">{t('company')}</Typography>
								<FormControl className='dropDownList'>
									<Select
										value={formValues.orgLevel0Code}
										id="outlined-disabled"
										disabled
									>
										{compList.map((compList, index) => (
											<MenuItem key={index} value={compList.orgLevel0Code}>
												{compList.comp}
											</MenuItem>
										))}
									</Select>
								</FormControl>
							</Box>

							<Box display="flex" className="boxDrop" alignItems="center" width="100%">
								<Typography className="label">{t('department')}</Typography>
								<FormControl className='dropDownList'>
									<Autocomplete
										id="department-select"
										options={filteredOrgLevel1Infos.map((dept) => ({
											label: dept.dept,
											value: dept.orgLevel1Code
										}))}
										freeSolo
										renderInput={(params) => <TextField {...params} placeholder={t('placeholder.1000300')} />}
										inputValue={formValues.departmentName}
										defaultValue={filteredOrgLevel1Infos.length > 0 ? { label: org1Abbr, value: formValues.orgLevel1Code } : null}
										onInputChange={(event, newValue) => {
											setFormValues({ ...formValues, departmentName: newValue });
										}}
										onChange={(event, newValue) => {
											if (typeof newValue === 'string') {
												setFormValues({ ...formValues, departmentName: newValue, orgLevel1Code: '' });
											} else if (newValue && newValue.label && newValue.value) {
												setFormValues({ ...formValues, departmentName: newValue.label, orgLevel1Code: newValue.value });
											} else {
												setFormValues({ ...formValues, departmentName: '', orgLevel1Code: '' });
											}
										}}
										disabled={!flgOrg1Selector}
									/>
									<FormHelperText style={{ color: 'red' }}>
										{validateDept(formValues.departmentName)}
									</FormHelperText>
								</FormControl>
							</Box>

							<Box display="flex" alignItems="center" width="100%">
								<Typography className="label">{t('email')}</Typography>
								<TextField
									className="textField"
									value={formValues.email}
									helperText={validateMail(formValues.email)}
									disabled={!flgMailAddress}
									onChange={(e) => setFormValues({ ...formValues, email: e.target.value })}
									FormHelperTextProps={{ className: 'red-helper-text' }}
									placeholder={t('placeholder.1000400')}
								/>
							</Box>

							<Box display="flex" className="boxDrop" alignItems="center" width="100%">
								<Typography className="label">{t('authority')}
									<Tooltip title={<span>■サービス管理者<br />ユーザの追加、変更の管理<br />フォルダへのアクセス権の管理<br />指定日時でのファイルアップロード<br />ファイルのアップロード、ダウンロード<br /><br />■運用者<br />指定日時でのファイルアップロード<br />ファイルのアップロード、ダウンロード<br /><br />■一般社員<br />ファイルのアップロード、ダウンロード<br /><br />■利用者<br />ファイルのアップロード、ダウンロード</span>} arrow>
										<svg width="15" height="15" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
											<circle cx="50" cy="50" r="40" fill="black" />
											<text x="50" y="70" font-size="80" text-anchor="middle" fill="white">?</text>
										</svg>
									</Tooltip>
								</Typography>
								<FormControl className='dropDownList'>
									<Select
										value={formValues.usrroleCode}
										onChange={(e) => setFormValues({ ...formValues, usrroleCode: e.target.value })}
										id="authority-select"
									>
										{filteredUserRoleDescs.map((userRoleList, index) => (
											<MenuItem key={index} value={userRoleList.usrroleCode}>
												{userRoleList.usrroleDesc}
											</MenuItem>
										))}
									</Select>
									<FormHelperText style={{ color: 'red' }}>
										{validateRole(formValues.usrroleCode)}
									</FormHelperText>
								</FormControl>
							</Box>

							<Box display="flex" alignItems="center" width="100%">
								<Typography className="label">{t('dateExpiry')}</Typography>
								<DatePicker
									defaultValue={formValues.expiryDate}
									onChange={(date) => setFormValues({ ...formValues, expiryDate: date })}
									helperText={validateExpiryDate(formValues.expiryDate)}
									placeholder="2999/12/31"
									dateFormat='yyyy/MM/DD'
									disabled={!flgExpiryDate}
								/>
							</Box>

							{/* ラベルとテーブルを同じコンテナで囲む */}
							<Box display="flex" flexDirection="column" width="100%" mt={2}>
								<Typography className="label" sx={{ mb: 1, ml: 0, fontSize: '14px', position: 'relative', left: '-20px' }}>
									設定済フォルダ権限
								</Typography>
								
								{/* テーブル全体 - 一つのスクロールコンテナ */}
								<Box sx={{ 
									height: '240px',
									border: '1px solid #ddd', 
									borderRadius: '4px',
									overflow: 'auto'
								}}>
									<Box sx={{ minWidth: '100%', minHeight: '100%' }}>
										{/* ヘッダー行 */}
										<Box display="flex" sx={{ 
											backgroundColor: '#e3f2fd',
											position: 'sticky',
											top: 0,
											zIndex: 10,
											borderBottom: '1px solid #ddd'
										}}>
											<Box sx={{ 
												width: '25%', 
												padding: '12px', 
												borderRight: '1px solid #ddd',
												fontWeight: 'bold',
												minWidth: '100px'
											}}>
												<Typography variant="body2">サービス名</Typography>
											</Box>
											<Box sx={{ 
												width: '25%',
												padding: '12px', 
												borderRight: '1px solid #ddd',
												fontWeight: 'bold',
												minWidth: '100px'
											}}>
												<Typography variant="body2">企業名</Typography>
											</Box>
											<Box sx={{ 
												width: '25%',
												padding: '12px', 
												borderRight: '1px solid #ddd',
												fontWeight: 'bold',
												minWidth: '100px'
											}}>
												<Typography variant="body2">フォルダ名</Typography>
											</Box>
											<Box sx={{ 
												width: '25%',
												padding: '12px',
												fontWeight: 'bold',
												minWidth: '100px'
											}}>
												<Typography variant="body2">フォルダ権限</Typography>
											</Box>
										</Box>
										
										{/* データ行 */}
										{folderPermissions.map((item, index) => (
											<Box key={index} display="flex" sx={{
												borderBottom: '1px solid #ddd',
												'&:hover': { backgroundColor: '#f9f9f9' }
											}}>
												<Box sx={{ 
													width: '25%', 
													padding: '12px', 
													borderRight: '1px solid #ddd',
													minWidth: '100px'
												}}>
													<Typography sx={{ fontSize: '11px' }}>{item.auditName}</Typography>
												</Box>
												<Box sx={{ 
													width: '25%',
													padding: '12px', 
													borderRight: '1px solid #ddd',
													minWidth: '100px'
												}}>
													<Typography sx={{ fontSize: '11px' }}>{item.orgName}</Typography>
												</Box>
												<Box sx={{ 
													width: '25%',
													padding: '12px', 
													borderRight: '1px solid #ddd',
													minWidth: '100px'
												}}>
													<Typography sx={{ fontSize: '11px' }}>{item.projName}</Typography>
												</Box>
												<Box sx={{ 
													width: '25%',
													padding: '12px',
													minWidth: '100px'
												}}>
													<Typography sx={{ fontSize: '11px' }}>{item.permission}</Typography>
												</Box>
											</Box>
										))}
										
										{folderPermissions.length === 0 && (
											<Box display="flex" justifyContent="center" sx={{ 
												padding: '20px',
												maxWidth: '100%',
												overflow: 'hidden', // 全てのスクロールを非表示
												borderBottom: '1px solid #ddd' // 追加
											}}>
												<Typography variant="body2" color="textSecondary" sx={{
													whiteSpace: 'nowrap' // テキストの改行を防ぐ
												}}>
													設定済みのフォルダ権限はありません
												</Typography>
											</Box>
										)}
									</Box>
								</Box>
							</Box>

						</Grid>
						<Grid container justifyContent="flex-end" className='button'>
							{resendInviteTargetFlg && (
								<Button
									className="resendInviteBtn"
									variant="primary"
									onClick={handleResendInviteBtnClick}
									style={{ width: '115px', marginRight: '15px', fontSize: '13px' }}
								>
									{t('resendInviteEmail')}
								</Button>
							)}
							<Tooltip 
								title={
									!deleteUserBtnAuthFlg 
									? "削除権限がありません" 
									: folderPermissions.length > 0 
										? "フォルダ権限が設定されているため削除できません" 
										: "このユーザーを削除可能です"
								}
								arrow
								>
								<span>
									<Button
										className="deleteBtn"
										variant="primary"
										onClick={handleDeleteUserBtnClick}
										disabled={!deleteUserBtnAuthFlg || folderPermissions.length > 0}
										style={{ width: '115px' }}
									>
									{t('delete')}
									</Button>
								</span>
							</Tooltip>							
							<Button
								className="userAddBtn"
								variant="primary"
								onClick={handleUpdateUserBtnClick}
								disabled={!updateUserSaveBtnAuthFlg || !nameJpVali || !nameEnVali || !emailVali || !org0Vali || !org1Vali || !roleVali}
							>
								{t('save')}
							</Button>
							<Button
								className="cancelBtn"
								variant="secondary"
								onClick={handleCancelClick}
							>
								{t('cancel')}
							</Button>
						</Grid>
					</CardContent>
				</Card>
				{dialogStatus === DIALOG_STATUS.DELETE_CONFIRM_DIALOG && (
					<ConfirmDialog
						isOpen={confirmDialogOpen}
						content={confirmDialogContent}
						onOk={onDeleteUserConfirmOK}
						onCancel={onCancel}
					/>
				)}
				{(dialogStatus === DIALOG_STATUS.OK_DIALOG || dialogStatus === DIALOG_STATUS.OK_DIALOG_BACK) && (
					<Dialog
						isOpen={dialogOpen}
						content={dialogContent}
						onOk={onOk}
					/>
				)}
				{(dialogStatus === DIALOG_STATUS.DETAIL_DIALOG || dialogStatus === DIALOG_STATUS.DETAIL_DIALOG_BACK) && (
					<DetailDialog
						isOpen={dialogOpen}
						content={dialogContent}
						detailContent={detailContent}
						onOk={onOk}
					/>
				)}
				{dialogStatus === DIALOG_STATUS.CONFIRM_DIALOG && (
					<ConfirmDialog
						isOpen={confirmDialogOpen}
						content={confirmDialogContent}
						onOk={onUpdateUserConfirmOK}
						onCancel={onCancel}
					/>
				)}
				{dialogStatus === DIALOG_STATUS.COMPLETE_DIALOG && (
					<Dialog
						isOpen={dialogOpen}
						content={dialogContent}
						onOk={onOk}
					/>
				)}
				{dialogStatus === DIALOG_STATUS.RESEND_INVITE_CONFIRM_DIALOG && (
					<ConfirmDialog
						isOpen={confirmDialogOpen}
						content={confirmDialogContent}
						onOk={onResendInviteConfirmOK}
						onCancel={onCancel}
					/>
				)}

			</Container>
		);
	}
}
export default UpdateUser;												
